import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

function RamApps({ apiCentral }) {
  const [memoryUsingApplications, setMemoryUsingApplications] = useState([

  ]);

  const socketRefs = useRef([]); // Usar un array para almacenar las conexiones de socket

  const socketUrls = [
    "https://service1-example-freeversion.onrender.com", // Primer servidor
    "https://service2-example-onrender.com",             // Segundo servidor (puedes añadir más)
  ];

  useEffect(() => {
    // Conectar a cada servidor en el array de URLs
    socketUrls.forEach((url, index) => {
      const socket = io(url, {
        path: '/socket',
        transports: ['websocket', 'polling'],
      });

      // Almacenar la referencia de cada socket en el array
      socketRefs.current[index] = socket;

      // Emitir la señal 'admin_conectado' para solicitar la información de memoria cuando el admin se conecta
      socket.emit('admin_conectado'); 

      // Escuchar los eventos de cada servidor para recibir la información de memoria solo una vez
      socket.once("memoryInfo", (memoryInfo) => { // Cambiado 'on' a 'once'
        const { data } = memoryInfo; // Extraer la propiedad 'data' de 'memoryInfo'
        setMemoryUsingApplications((prevState) => [
          ...prevState,
          {
            nameRestaurant: memoryInfo.nameRestaurant,
            serviceNumber: memoryInfo.serviceNumber,
            heapTotal: data.heapTotal,
            heapUsed: data.heapUsed,
            external: data.external,
            rss: data.rss
          }
        ]);
      });
    });

    // Limpiar las conexiones de sockets cuando el componente se desmonte
    return () => {
      socketRefs.current.forEach((socket) => {
        socket.disconnect();
      });
    };
  }, []); // Solo se ejecuta al montar el componente

  return (
    <div className="dashboard-restaurantes-container">
      <h2 className="dashboard-restaurantes-title">Estadísticas de Memoria</h2>
      <table className="restaurantes-data-table">
        <thead>
          <tr>
            <th>Nombre Restaurante</th>
            <th>Número de Servicio</th>
            <th>Memoria Total Asignada (MB)</th>
            <th>Memoria Usada (MB)</th>
            <th>Memoria Externa (MB)</th>
            <th>Tamaño RSS (MB)</th>
          </tr>
        </thead>
        <tbody>
          {memoryUsingApplications.length > 0 ? (
            memoryUsingApplications.map((restaurant, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'center' }}>{restaurant.nameRestaurant}</td>
                <td style={{ textAlign: 'center' }}>{restaurant.serviceNumber}</td>
                <td style={{ textAlign: 'center' }}>
                  {(restaurant.heapTotal / 1024 / 1024).toFixed(2)} MB
                </td>
                <td style={{ textAlign: 'center' }}>
                  {(restaurant.heapUsed / 1024 / 1024).toFixed(2)} MB
                </td>
                <td style={{ textAlign: 'center' }}>
                  {(restaurant.external / 1024 / 1024).toFixed(2)} MB
                </td>
                <td style={{ textAlign: 'center' }}>
                  {(restaurant.rss / 1024 / 1024).toFixed(2)} MB
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No hay datos disponibles</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default RamApps;
